export default __webpack_public_path__ + "00a4b01edbea1e5e0d5541e7653ae42e.png";